<template>
    <span>{{ humanReadableTime }}</span>
</template>

<script>
export default {
    props: {
        startingSeconds: {
            type: Number,
            required: true,
            default: 0
        },
        fullString: {
            type: Boolean,
            required:false,
            default: false
        },
        suffix: {
            type: String,
            required:false,
            default: ''
        }
    },
    data() {
        return {
            seconds: this.startingSeconds
        };
    },
    mounted() {
        const timer = setInterval(() => {
            this.seconds--;
        }, 1000);
    },
    computed: {
        humanReadableTime() {
            const years = Math.floor(this.seconds / 31536000); // 365 * 24 * 60 * 60
            const months = Math.floor((this.seconds % 31536000) / 2628000); // 30.44 * 24 * 60 * 60
            const days = Math.floor((this.seconds % 2628000) / 86400); // 24 * 60 * 60
            const hours = Math.floor((this.seconds % 86400) / 3600);
            const minutes = Math.floor((this.seconds % 3600) / 60);
            const seconds = this.seconds % 60;


            if (this.fullString) {
                let timeString = '';

                if (years > 0) {
                    timeString += `${years} ${years === 1 ? 'year' : 'years'}`;
                }

                if (months > 0) {
                    timeString += ` ${months} ${months === 1 ? 'month' : 'months'}`;
                }

                if (days > 0) {
                    timeString += ` ${days} ${days === 1 ? 'day' : 'days'}`;
                }

                if (hours > 0) {
                    timeString += ` ${hours} ${hours === 1 ? 'hour' : 'hours'}`;
                }

                if (minutes > 0) {
                    timeString += ` ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
                }

                if (seconds > 0) {
                    timeString += ` ${seconds} ${seconds === 1 ? 'second' : 'seconds'}`;
                }

                return (timeString.trim() || 'Ended') + this.suffix;

            }

            if (years > 0) {
                return `${years} ${years === 1 ? 'year' : 'years'}`;
            }

            if (months > 0) {
                return ` ${months} ${months === 1 ? 'month' : 'months'}`;
            }

            if (days > 0) {
                return ` ${days} ${days === 1 ? 'day' : 'days'}`;
            }

            if (hours > 0) {
                return ` ${hours} ${hours === 1 ? 'hour' : 'hours'}`;
            }

            if (minutes > 0) {
                return ` ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
            }

            if (seconds > 0) {
                return ` ${seconds} ${seconds === 1 ? 'second' : 'seconds'}`;
            }

            return 'Ended' + this.suffix;
        }
    }
};
</script>
